import { LogTag } from '../../models/logTags';

export enum TryFetchLogTagsStatus {
  NotStartedYet,
  InProgress,
  Succeeded,
  Failed,
}

export interface TryFetchLogTagsState {
  status: TryFetchLogTagsStatus;
  logTags: LogTag[] | undefined;
}

export type AxiosResponseStatus = number | undefined;
